import { ReactNode, useMemo } from 'react'
import { faLocationCrosshairs, faPlus, faMinus } from '@fortawesome/free-solid-svg-icons'
import CompassIcon from 'src/assets/compass.svg'
import { ControlButton, ControlButtonsGroup, CtrBtnIcons } from './ControlButton'
import { MapLayer, MapLayers } from '../../meta'
import Styles from './SideControlButtonGroup.module.scss'
import { config } from 'src/config'

type SideControlButtonGroupProps = {
  selectedLayer: MapLayer | string | undefined
  rotateDegree: number
  tiltDegree: number
  onSelectLayer: (layer: MapLayer) => void
  onZoomIn: () => void
  onZoomOut: () => void
  onResetNorth: () => void
  onLocate: () => void
  onToggleTilt: () => void
  className?: string
}

export const SideControlButtonGroup = ({
  selectedLayer,
  rotateDegree,
  tiltDegree,
  onSelectLayer,
  onZoomIn,
  onZoomOut,
  onResetNorth,
  onLocate,
  onToggleTilt,
  className,
}: SideControlButtonGroupProps) => {
  const layerButtons = useMemo(
    () =>
      MapLayers.map(layer => (
        <ControlButton
          key={layer}
          onClick={() => onSelectLayer(layer)}
          selected={selectedLayer === layer}
          iconName={CtrBtnIcons[layer]}
          tooltip={layer}
        />
      )),
    [onSelectLayer, selectedLayer],
  )

  return (
    <div className={[Styles.sideControls, className].filter(Boolean).join(' ')}>
      <ControlButtonsGroup
        buttons={[
          <ControlButton key="cb0" onClick={onZoomIn} tooltip={'zoom in'} iconName={faPlus} />,
          <ControlButton key="cb1" onClick={onZoomOut} tooltip={'zoom out'} iconName={faMinus} />,
          <ControlButton
            key="cb2"
            onClick={onResetNorth}
            tooltip={'reset North'}
            icon={
              <img
                src={CompassIcon}
                alt="Compass"
                className={Styles.compass}
                style={{ transform: `rotate(${-1 * rotateDegree}deg)` }}
              />
            }
          />,
        ]}
      />
      {!config.disableControlLocate && (
        <ControlButton key="cb3" onClick={onLocate} tooltip={'find my location'} iconName={faLocationCrosshairs} />
      )}
      <ControlButton
        key="cb4"
        onClick={onToggleTilt}
        tooltip={'tilt'}
        selected={tiltDegree}
        icon={<label style={{ transform: `rotate3d(1, 0, 0, ${tiltDegree}deg)` }}>{'3D'}</label>}
      />
      {layerButtons}
    </div>
  )
}